import React, { FC, useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControlLabel,
    Checkbox,
    Box,
    Typography
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useTranslation } from 'react-i18next';
import { MenuCommand } from '../../../services/command';
import Swal from 'sweetalert2';

interface IProps {
    selectedRow?: any;
    open?: boolean;
    onClose?: any;
    refresh?: any;
}

export const SCUIMenuCopyDialog: FC<IProps> = ({ selectedRow = null, open = false, onClose, refresh }) => {
    const { t } = useTranslation();
    const [copyChildren, setCopyChildren] = useState(true);
    const [copyRoles, setCopyRoles] = useState(true);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (open) {
            setCopyChildren(true);
            setCopyRoles(true);
        }
    }, [open]);

    const handleCopy = () => {
        setLoading(true);
        const payload = {
            MenuId: selectedRow?.menuItemId,
            CopyChildren: copyChildren,
            CopyRoles: copyRoles
        };

        MenuCommand.PostMenuCopy(payload)
            .then(() => {
                Swal.fire(t('menuManagement.copySuccess'), ' ', 'success');
                refresh();
                onClose();
            })
            .catch((error: any) => {
                console.log('Error in copy menu:', error);
                Swal.fire(t('menuManagement.copyFailed'), ' ', 'error');
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle
                sx={{
                    backgroundColor: '#f8f9fa',
                    borderBottom: '2px solid #e3f2fd',
                    padding: '20px 24px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    fontSize: '20px',
                    fontWeight: '600',
                    color: '#1976d2',
                }}
            >
                <ContentCopyIcon sx={{ width: '24px', height: '24px', color: '#1976d2' }} />
                {t('menuManagement.copyTitle')} - {selectedRow?.text}
            </DialogTitle>
            <DialogContent sx={{ mt: 2 }}>
                <Box display="flex" flexDirection="column" gap={2}>
                    <Typography variant="body1">
                        {t('menuManagement.copyDescription')}
                    </Typography>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={copyChildren}
                                onChange={(e) => setCopyChildren(e.target.checked)}
                            />
                        }
                        label={t('menuManagement.copyChildMenus')}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={copyRoles}
                                onChange={(e) => setCopyRoles(e.target.checked)}
                            />
                        }
                        label={t('menuManagement.copyWithRoles')}
                    />
                </Box>
            </DialogContent>
            <DialogActions sx={{ p: 3, pt: 0 }}>
                <Button onClick={onClose} color="inherit" disabled={loading}>
                    {t('general.cancel')}
                </Button>
                <Button onClick={handleCopy} variant="contained" color="primary" disabled={loading}>
                    {loading ? '...' : t('menuManagement.copy')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};